var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CcDownload',{attrs:{"show-logo":false,"data":_vm.data,"download":_vm.download}})
}
var staticRenderFns = []

export { render, staticRenderFns }